// Back-compat facade over the brand registry (`@shared/brand`).
// Existing imports (APP_NAME, FEATURES, etc.) keep working; new code should
// prefer importing BRAND / hasFeature from "@shared/brand" directly.

import { BRAND, hasFeature } from "../brand";

export { BRAND, hasFeature };

export const APP_NAME = BRAND.appName;
export const LOGO = BRAND.logo;
export const VIDEOS_LABEL = BRAND.labels.videos;
export const MY_VIDEOS_LABEL = BRAND.labels.myVideos;
export const SEARCH_PLACEHOLDER = BRAND.labels.search;

export const FOOTER = BRAND.footer;

export const FEATURES = BRAND.marketing.features;
export const PERSONAS = BRAND.marketing.personas;
export const HERO = BRAND.marketing.hero;
export const LOGIN_VISITOR = BRAND.marketing.loginVisitor;
export const SECTIONS = BRAND.marketing.sections;

export const PRICING = null;
export const ROADMAP_CALL_BOOKING_URL =
  "https://outlook.office.com/bookwithme/user/4b8f1a7e27744395afd33ae2bcfb6628@ringdigital.tv?anonymous&ismsaljsauthenabled&ep=plink";
export const ENTERPRISE_REVIEW_BOOKING_URL =
  "https://outlook.office.com/book/brian@ringdigital.tv/";

export const CONTENT_LABEL = BRAND.labels.content;
export const CONTENT_LABEL_SINGULAR = BRAND.labels.contentSingular;

export const fmtTC = (tc) => (tc || "").replace(/^00:/, "");

export const BLOG_LABEL = BRAND.marketing.blogLabel;

export const CHAT_THEME = BRAND.theme.chat;
